import { useOrgSettings } from '@/api/queries/useOrgSettings';

export function useAiEnabled() {
  const { data: settings, isLoading } = useOrgSettings();
  const aiEnabled = settings?.enableAI ?? false;

  return {
    isLoading,
    aiEnabled,
    bliksyEnabled: aiEnabled && (settings?.ai?.enableBliksy ?? false),
    stepNameGenerationEnabled: aiEnabled && (settings?.ai?.enableStepNameGeneration ?? false)
  };
}
